import React, { useEffect, useRef, useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import { Link, useNavigate } from "react-router-dom";
import "./addEvents.css";
import { useSelector, useDispatch } from "react-redux";
import { addEvent } from "../../Redux/Actions/eventActions";
import AddImage from "../../Global Functions/addImage";
import {
  viewCountryList,
  viewCityList,
  viewStateListPagination,
} from "../../Redux/Actions/settingsActions";
import toast from "react-hot-toast";
import { sendNotification } from "../../Redux/Actions/notificationActions";
import ImageShowerModalGlobal from "../../Global Functions/imageShowerModalGlobal";
import { viewBuilderList } from "../../Redux/Actions/builderActions";
import { getEnums } from "../../Redux/Actions/enumsActions";
import { ToFirstCapital } from "../../Utils/helpers";
import MapsAddress from "../../Global Functions/mapsAddress";

const AddEvents = () => {
  const navigate = useNavigate();
  const startDateRef = useRef(null);
  const dispatch = useDispatch();

  const [selectedType, setSelectedType] = useState("");
  const [guestData, setGuestData] = useState({
    name: "",
    image: "",
    designation: "",
    organization: "",
  });
  const [trailerVideoData, setTrailerVideoData] = useState({
    url: "",
    type: "video",
    index: 0,
  });
  const [threeSixtyData, setThreeSixtyData] = useState({
    configuration: "",
    iframe_url: "",
    is_user_vr: true,
  });

  const [eventPayload, setEventPayload] = useState({
    type: "",
    event_name: "",
    event_image: "",
    start_date: "",
    start_time: "",
    end_date: "",
    end_time: "",
    start_date_utc: "",
    end_date_utc: "",
    builder: "",
    lat: "",
    lng: "",
    about_event: "",
    address: "",
    cover_photo: "",
    guest_list: [],
    country: "",
    state: "",
    city: "",
    youtube_link: "",
    video: "",
    image: [],
    trailer_videos: [],
    three_sixty: [],
  });

  const { countryList } = useSelector((state) => state.country || {});
  const { states } = useSelector((state) => state.states || {});
  const { cities } = useSelector((state) => state.city || {});
  const { builders } = useSelector((state) => state.builders || {});
  const { enumsData } = useSelector((state) => state.enumsData || {});
  const [videoUploading, setVideoUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  const isComingSoon = selectedType?.toLowerCase() === "coming_soon";
  const isTrailer = selectedType?.toLowerCase() === "trailer";

  const buildUTCDateTime = (date, time) => {
    if (!date || !time) return "";
    const localDateTime = new Date(`${date}T${time}:00`);
    if (isNaN(localDateTime.getTime())) return "";
    return localDateTime.toISOString();
  };

  const handleAddChange = (e) => {
    const { name, value } = e.target;

    setEventPayload((prevData) => {
      const updatedPayload = { ...prevData, [name]: value };

      if (updatedPayload.startdate && updatedPayload.starttime) {
        updatedPayload.startdateutc = buildUTCDateTime(
          updatedPayload.startdate,
          updatedPayload.starttime
        );
      }

      if (updatedPayload.enddate && updatedPayload.endtime) {
        updatedPayload.enddateutc = buildUTCDateTime(
          updatedPayload.enddate,
          updatedPayload.endtime
        );
      }

      if (
        ["starttime", "endtime", "startdate", "enddate"].includes(name) &&
        updatedPayload.startdate === updatedPayload.enddate
      ) {
        if (
          updatedPayload.starttime &&
          updatedPayload.endtime &&
          updatedPayload.starttime > updatedPayload.endtime
        ) {
          alert("Start time cannot be after end time on the same day.");
          return prevData;
        }
      }

      return updatedPayload;
    });
  };

  const handleAddressChange = ({ lat, lng }) => {
    setEventPayload((prev) => ({
      ...prev,
      lat: lat || "",
      lng: lng || "",
    }));
  };

  const guestAdditionHandler = (event) => {
    event.preventDefault();
    if (guestData.name.trim()) {
      setEventPayload((prev) => ({
        ...prev,
        guest_list: [...(prev.guest_list || []), guestData],
      }));
      toast.success("Guest Added Successfully!!");
      setGuestData({ name: "", image: "", designation: "", organization: "" });
    } else {
      toast.error("Problem adding Guest!!");
    }
  };

  const handleGuestAdd = (event) => {
    const { name, value } = event.target;
    setGuestData((prevData) => ({ ...prevData, [name]: value }));
  };

  const cleanPayload = (payload) => {
    const isEmpty = (value) => value === "" || value === null || value === undefined;
    const isGuestEmpty = (guest) => Object.values(guest).every((val) => isEmpty(val));
    const cleaned = {};

    for (const [key, value] of Object.entries(payload)) {
      if (key === "guest_list" && Array.isArray(value)) {
        const filteredGuests = value.filter((guest) => !isGuestEmpty(guest));
        if (filteredGuests.length > 0) cleaned[key] = filteredGuests;
      } else if (Array.isArray(value) && value.length > 0) {
        cleaned[key] = value;
      } else if (!isEmpty(value)) {
        cleaned[key] = value;
      }
    }

    return cleaned;
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!eventPayload.type) {
      toast.error("You have to select Event type");
      return;
    }

    if (isTrailer) {
      if (!eventPayload.event_name?.trim()) {
        toast.error("Trailer Name is required");
        return;
      }
      if (!eventPayload.about_event?.trim()) {
        toast.error("About is required");
        return;
      }
      if (!eventPayload.start_date) {
        toast.error("Start Date is required");
        return;
      }
      if (!eventPayload.start_time) {
        toast.error("Start Time is required");
        return;
      }
      if (!eventPayload.end_date) {
        toast.error("End Date is required");
        return;
      }
      if (!eventPayload.end_time) {
        toast.error("End Time is required");
        return;
      }
      if (!eventPayload.trailer_videos || eventPayload.trailer_videos.length === 0) {
        toast.error("At least one Trailer Video is required");
        return;
      }
    } else {
      if (!eventPayload.event_name?.trim()) {
        toast.error("Event Name is required");
        return;
      }
      if (!eventPayload.about_event?.trim()) {
        toast.error("About is required");
        return;
      }
      if (!eventPayload.start_date) {
        toast.error("Start Date is required");
        return;
      }
      if (!eventPayload.start_time) {
        toast.error("Start Time is required");
        return;
      }
      if (!eventPayload.end_date) {
        toast.error("End Date is required");
        return;
      }
      if (!eventPayload.end_time) {
        toast.error("End Time is required");
        return;
      }
      if (!eventPayload.address?.trim()) {
        toast.error("Address is required");
        return;
      }
      if (!eventPayload.cover_photo?.trim()) {
        toast.error("Cover Photo is required");
        return;
      }
      if (isComingSoon && !eventPayload.builder?.trim()) {
        toast.error("Builder is required for Coming Soon events");
        return;
      }
    }

    const finalPayload = {
      ...eventPayload,
      start_date_utc: buildUTCDateTime(
        eventPayload.start_date,
        eventPayload.start_time
      ),
      end_date_utc: buildUTCDateTime(
        eventPayload.end_date,
        eventPayload.end_time
      ),
    };

    const cleanedPayload = cleanPayload(finalPayload);

    const submitEventData = async () => {
      try {
        const response = await dispatch(addEvent(cleanedPayload));
        if (response.statusCode === 200) {
          if (!isTrailer) {
            try {
              await dispatch(
                sendNotification({
                  title: "New Event Added",
                  message: `New event "${eventPayload.event_name}" has been added!`,
                  type_name: "none",
                  type_id: response?.data?._id || "",
                  type: "all",
                  notification_for: "user",
                  list: [],
                  image: eventPayload.cover_photo,
                  type_data: {
                    event_name: eventPayload.event_name,
                    about_event: eventPayload.about_event,
                    start_date: eventPayload.start_date,
                    end_date: eventPayload.end_date,
                    type: eventPayload.type,
                  },
                })
              );
            } catch (notificationError) {
              console.error("Notification failed:", notificationError);
            }
          }

          toast.success("Event added successfully!");
          navigate("/event");
        }
      } catch (error) {
        toast.error(error?.message || "Something went wrong");
      }
    };

    submitEventData();
  };

  useEffect(() => {
    const countryData = { page: 1, limit: 250 };
    dispatch(viewCountryList(countryData));

    if (eventPayload?.country) {
      dispatch(viewStateListPagination({ country: eventPayload.country }));
    }

    if (eventPayload?.state) {
      dispatch(
        viewCityList({
          page: 1,
          limit: 200,
          state: eventPayload.state,
          country: eventPayload.country,
        })
      );
    }
  }, [dispatch, eventPayload?.country, eventPayload?.state]);

  useEffect(() => {
    dispatch(getEnums());
    dispatch(viewBuilderList({ page: 1, limit: 1000, is_deleted: false }));
  }, [dispatch]);

  const addHoursToTime = (timeStr, hoursToAdd) => {
    if (!timeStr) return "00:00";
    let [h, m] = timeStr.split(":").map(Number);
    h += hoursToAdd;
    if (h >= 24) h = 23;
    return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
  };

  const isSameDate = eventPayload.start_date === eventPayload.end_date;
  const minEndTime = isSameDate ? addHoursToTime(eventPayload.start_time, 3) : "00:00";

  const eventTypesEnums = enumsData?.data?.eventType
    ? Object.values(enumsData.data.eventType).map((item) => item)
    : [];

  const typeSelectionHandler = (event) => {
    const updatedType = event.target.value;
    if (!updatedType) return toast.error("Please select a type - Event or Coming Soon");
    setSelectedType(updatedType);
    setEventPayload((prevData) => ({ ...prevData, type: updatedType }));
  };

  const validImageTypes = ["image/jpeg", "image/jpg", "image/png", "image/svg+xml"];
  const validVideoTypes = [
    "video/mp4",
    "video/avi",
    "video/mov",
    "video/wmv",
    "video/mkv",
    "video/webm",
  ];

  const handleMediaUpload = async (event, targetKey, mediaType) => {
    const uploadedFile = event.target.files[0];
    if (!uploadedFile) {
      toast.error("No File Uploaded");
      return;
    }

    const validTypes = mediaType === "image" ? validImageTypes : validVideoTypes;
    if (!validTypes.includes(uploadedFile.type)) {
      toast.error(`Only ${mediaType} files are allowed!`);
      event.target.value = "";
      return;
    }

    if (targetKey === "video" || targetKey === "trailer_video") {
      setVideoUploading(true);
      setUploadProgress(0);

      const progressInterval = setInterval(() => {
        setUploadProgress((prev) => {
          if (prev >= 90) {
            clearInterval(progressInterval);
            return 90;
          }
          return prev + 10;
        });
      }, 300);

      const responseUrl = await AddImage(uploadedFile);
      clearInterval(progressInterval);
      setUploadProgress(100);

      if (responseUrl) {
        if (targetKey === "trailer_video") {
          setTrailerVideoData((prevData) => ({ ...prevData, url: responseUrl }));
          toast.success("Video uploaded successfully!");
        } else {
          setEventPayload((prevData) => ({ ...prevData, [targetKey]: responseUrl }));
        }
        event.target.value = "";
      }

      setVideoUploading(false);
      setTimeout(() => setUploadProgress(0), 1000);
    } else {
      const responseUrl = await AddImage(uploadedFile);
      if (responseUrl) {
        if (targetKey === "guest_image") {
          setGuestData((prevData) => ({ ...prevData, image: responseUrl }));
        } else if (targetKey === "image") {
          setEventPayload((prevData) => ({
            ...prevData,
            image: [...(prevData.image || []), responseUrl],
          }));
        } else {
          setEventPayload((prevData) => ({ ...prevData, [targetKey]: responseUrl }));
        }
        event.target.value = "";
      }
    }
  };

  const addTrailerVideoHandler = (event) => {
    event.preventDefault();
    if (trailerVideoData.url.trim()) {
      setEventPayload((prev) => ({
        ...prev,
        trailer_videos: [
          ...(prev.trailer_videos || []),
          {
            url: trailerVideoData.url,
            type: "video",
            index: prev.trailer_videos?.length || 0,
          },
        ],
      }));
      toast.success("Trailer Video Added Successfully!!");
      setTrailerVideoData({ url: "", type: "video", index: 0 });
    } else {
      toast.error("Please provide a video URL!!");
    }
  };

  const removeTrailerVideo = (index) => {
    setEventPayload((prevData) => ({
      ...prevData,
      trailer_videos: prevData.trailer_videos.filter((_, i) => i !== index),
    }));
    toast.success("Trailer Video Removed!");
  };

  const addThreeSixtyHandler = (event) => {
    event.preventDefault();
    if (threeSixtyData.configuration.trim() && threeSixtyData.iframe_url.trim()) {
      setEventPayload((prev) => ({
        ...prev,
        three_sixty: [...(prev.three_sixty || []), threeSixtyData],
      }));
      toast.success("360 Content Added Successfully!!");
      setThreeSixtyData({ configuration: "", iframe_url: "", is_user_vr: true });
    } else {
      toast.error("Please fill in all required fields!!");
    }
  };

  const removeThreeSixty = (index) => {
    setEventPayload((prevData) => ({
      ...prevData,
      three_sixty: prevData.three_sixty.filter((_, i) => i !== index),
    }));
    toast.success("360 Content Removed!");
  };

  return (
    <MainLayout>
      <div className="acp-wrapper">
        <div className="acp-header">
          <div className="acp-header-left">
            <div className="acp-header-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                <line x1="16" y1="2" x2="16" y2="6" />
                <line x1="8" y1="2" x2="8" y2="6" />
                <line x1="3" y1="10" x2="21" y2="10" />
              </svg>
            </div>
            <div>
              <h1 className="acp-title">Add Event</h1>
              <p className="acp-subtitle">Fill in the details to create a new event</p>
            </div>
          </div>
          <button className="acp-view-btn" type="button" onClick={() => navigate("/event")}>
            View Events
          </button>
        </div>

        <form onSubmit={handleSubmit} className="acp-form">
          <div className="acp-card">
            <div className="acp-card-header">
              <span className="acp-card-badge">01</span>
              <h2 className="acp-card-title">Event Type</h2>
            </div>
            <div className="acp-grid acp-grid-2">
              <div className="acp-field">
                <label className="acp-label">
                  Select Type <span className="acp-req">*</span>
                </label>
                <select className="acp-select" onChange={typeSelectionHandler} value={eventPayload.type}>
                  <option value="">Select an Option</option>
                  {Array.isArray(eventTypesEnums) &&
                    eventTypesEnums.map((enums) => (
                      <option key={enums} value={enums}>
                        {ToFirstCapital(enums)}
                      </option>
                    ))}
                </select>
              </div>
            </div>
          </div>

          <div className="acp-card">
            <div className="acp-card-header">
              <span className="acp-card-badge">02</span>
              <h2 className="acp-card-title">Basic Information</h2>
            </div>
            <div className="acp-grid acp-grid-2">
              <div className="acp-field">
                <label className="acp-label">
                  {isTrailer ? "Trailer Name" : "Event Name"} <span className="acp-req">*</span>
                </label>
                <input
                  className="acp-input"
                  disabled={!selectedType}
                  type="text"
                  name="event_name"
                  value={eventPayload.event_name}
                  onChange={handleAddChange}
                  placeholder={isTrailer ? "Enter trailer name" : "Enter event name"}
                />
              </div>

              {isComingSoon && (
                <div className="acp-field">
                  <label className="acp-label">Select Builder</label>
                  <select
                    className="acp-select"
                    name="builder"
                    value={eventPayload.builder}
                    onChange={handleAddChange}
                    disabled={!selectedType}
                  >
                    <option value="">Select an Option</option>
                    {Array.isArray(builders?.data) &&
                      builders.data.map((builder) => (
                        <option key={builder._id} value={builder._id}>
                          {builder.brand_name}
                        </option>
                      ))}
                  </select>
                </div>
              )}

              <div className="acp-field" style={{ gridColumn: "1 / -1" }}>
                <label className="acp-label">
                  About <span className="acp-req">*</span>
                </label>
                <textarea
                  className="acp-textarea"
                  disabled={!selectedType}
                  name="about_event"
                  value={eventPayload.about_event}
                  onChange={handleAddChange}
                  placeholder="Describe your event"
                  rows={4}
                />
              </div>
            </div>
          </div>

          <div className="acp-card">
            <div className="acp-card-header">
              <span className="acp-card-badge">03</span>
              <h2 className="acp-card-title">Date & Time</h2>
            </div>
            <div className="acp-grid acp-grid-2">
              <div className="acp-field">
                <label className="acp-label">
                  Start Date <span className="acp-req">*</span>
                </label>
                <input
                  ref={startDateRef}
                  className="acp-input"
                  min={new Date().toISOString().split("T")[0]}
                  disabled={!selectedType}
                  max={eventPayload.end_date}
                  type="date"
                  name="start_date"
                  value={eventPayload.start_date}
                  onChange={handleAddChange}
                />
              </div>

              <div className="acp-field">
                <label className="acp-label">
                  Start Time <span className="acp-req">*</span>
                </label>
                <input
                  className="acp-input"
                  type="time"
                  name="start_time"
                  disabled={!selectedType}
                  value={eventPayload.start_time}
                  onChange={handleAddChange}
                />
              </div>

              <div className="acp-field">
                <label className="acp-label">
                  End Date <span className="acp-req">*</span>
                </label>
                <input
                  className="acp-input"
                  min={eventPayload.start_date}
                  disabled={!selectedType}
                  type="date"
                  name="end_date"
                  value={eventPayload.end_date}
                  onChange={handleAddChange}
                />
              </div>

              <div className="acp-field">
                <label className="acp-label">
                  End Time <span className="acp-req">*</span>
                </label>
                <input
                  className="acp-input"
                  disabled={!selectedType}
                  min={minEndTime}
                  type="time"
                  name="end_time"
                  value={eventPayload.end_time}
                  onChange={handleAddChange}
                />
              </div>
            </div>
          </div>

          <div className="acp-card">
            <div className="acp-card-header">
              <span className="acp-card-badge">04</span>
              <h2 className="acp-card-title">Media</h2>
            </div>

            {selectedType?.toLowerCase() !== "trailer" ? (
              <>
                <div className="acp-grid acp-grid-2">
                  <div className="acp-field">
                    <label className="acp-label">
                      Cover Photo <span className="acp-req">*</span>
                    </label>
                    <input
                      id="cover_photo"
                      className="acp-input"
                      type="file"
                      disabled={!selectedType}
                      accept="image/jpeg, image/jpg, image/png, image/svg+xml"
                      name="cover_photo"
                      onChange={(e) => handleMediaUpload(e, "cover_photo", "image")}
                    />
                    <ImageShowerModalGlobal
                      state={eventPayload}
                      setState={setEventPayload}
                      keyField="cover_photo"
                      file={eventPayload.cover_photo}
                    />
                  </div>

                  <div className="acp-field">
                    <label className="acp-label">Event Image</label>
                    <input
                      className="acp-input"
                      type="file"
                      accept="image/jpeg, image/jpg, image/png, image/svg+xml"
                      name="event_image"
                      disabled={!selectedType}
                      onChange={(e) => handleMediaUpload(e, "event_image", "image")}
                    />
                    <ImageShowerModalGlobal
                      state={eventPayload}
                      setState={setEventPayload}
                      keyField="event_image"
                      file={eventPayload.event_image}
                    />
                  </div>

                  <div className="acp-field">
                    <label className="acp-label">Upload Video</label>
                    <input
                      className="acp-input"
                      type="file"
                      name="video"
                      accept="video/mp4, video/avi, video/mov, video/wmv, video/mkv, video/webm"
                      disabled={!selectedType}
                      onChange={(e) => handleMediaUpload(e, "video", "video")}
                    />
                    {videoUploading && (
                      <div style={{ marginTop: 8 }}>
                        <p style={{ fontSize: 13, color: "#6b7280", marginBottom: 6 }}>
                          Uploading video... {uploadProgress}%
                        </p>
                        <div
                          style={{
                            width: "100%",
                            height: 8,
                            background: "#f1f5f9",
                            borderRadius: 8,
                            overflow: "hidden",
                          }}
                        >
                          <div
                            style={{
                              height: "100%",
                              width: `${uploadProgress}%`,
                              background: uploadProgress === 100 ? "#10b981" : "#3b82f6",
                              borderRadius: 8,
                              transition: "width 0.3s ease",
                            }}
                          />
                        </div>
                      </div>
                    )}
                    {eventPayload.video && (
                      <div style={{ position: "relative", marginTop: 10, display: "inline-block" }}>
                        <video controls style={{ width: 280, height: 180, borderRadius: 10, objectFit: "cover", display: "block" }}>
                          <source src={eventPayload.video} type="video/mp4" />
                        </video>
                        <button
                          type="button"
                          onClick={() => setEventPayload((prev) => ({ ...prev, video: "" }))}
                          style={{
                            position: "absolute",
                            top: 6,
                            right: 6,
                            background: "#ef4444",
                            color: "#fff",
                            border: "none",
                            borderRadius: "50%",
                            width: 24,
                            height: 24,
                            cursor: "pointer",
                            fontSize: 16,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          ×
                        </button>
                      </div>
                    )}
                  </div>
                </div>

                <div className="acp-field" style={{ marginTop: 18 }}>
                  <label className="acp-label">
                    Youtube Link 
                  </label>
                  <input
                    className="acp-input"
                    type="text"
                    disabled={!selectedType}
                    name="youtube_link"
                    value={eventPayload.youtube_link}
                    onChange={handleAddChange}
                    placeholder="https://youtube.com/..."
                  />
                </div>
              </>
            ) : (
              <>
                <div style={{ marginBottom: 24 }}>
                  <h3 style={{ fontSize: 15, fontWeight: 600, color: "#111827", marginBottom: 16, paddingBottom: 12, borderBottom: "1px solid #e4e7ec" }}>
                    Cover Photo
                  </h3>
                  <div className="acp-grid acp-grid-2">
                    <div className="acp-field">
                      <label className="acp-label">Cover Photo</label>
                      <input
                        className="acp-input"
                        type="file"
                        accept="image/jpeg, image/jpg, image/png, image/svg+xml"
                        onChange={(e) => handleMediaUpload(e, "cover_photo", "image")}
                      />
                      <ImageShowerModalGlobal
                        state={eventPayload}
                        setState={setEventPayload}
                        keyField="cover_photo"
                        file={eventPayload.cover_photo}
                      />
                    </div>
                  </div>
                </div>

                <div style={{ marginBottom: 24 }}>
                  <h3 style={{ fontSize: 15, fontWeight: 600, color: "#111827", marginBottom: 16, paddingBottom: 12, borderBottom: "1px solid #e4e7ec" }}>
                    Trailer Videos
                  </h3>
                  <div style={{ display: "grid", gridTemplateColumns: "400px 1fr", gap: 24 }}>
                    <div style={{ background: "#f9fafb", border: "1px solid #e4e7ec", borderRadius: 12, padding: 20 }}>
                      <p style={{ fontSize: 14, fontWeight: 600, color: "#374151", marginBottom: 16 }}>
                        Add Trailer Video
                      </p>
                      <div className="acp-field" style={{ marginBottom: 14 }}>
                        <label className="acp-label">Upload Video</label>
                        <input
                          className="acp-input"
                          type="file"
                          accept="video/mp4, video/avi, video/mov, video/wmv, video/mkv, video/webm"
                          onChange={(e) => handleMediaUpload(e, "trailer_video", "video")}
                        />
                      </div>

                      {videoUploading && (
                        <div style={{ marginBottom: 14 }}>
                          <p style={{ fontSize: 13, color: "#6b7280", marginBottom: 6 }}>
                            Uploading... {uploadProgress}%
                          </p>
                          <div style={{ width: "100%", height: 8, background: "#e5e7eb", borderRadius: 8, overflow: "hidden" }}>
                            <div
                              style={{
                                height: "100%",
                                width: `${uploadProgress}%`,
                                background: uploadProgress === 100 ? "#10b981" : "#3b82f6",
                                borderRadius: 8,
                                transition: "width 0.3s ease",
                              }}
                            />
                          </div>
                        </div>
                      )}

                      {trailerVideoData.url && (
                        <div style={{ position: "relative", marginBottom: 14 }}>
                          <video controls style={{ width: "100%", borderRadius: 10, objectFit: "cover" }}>
                            <source src={trailerVideoData.url} type="video/mp4" />
                          </video>
                          <button
                            type="button"
                            onClick={() => setTrailerVideoData({ ...trailerVideoData, url: "" })}
                            style={{
                              position: "absolute",
                              top: 6,
                              right: 6,
                              background: "#ef4444",
                              color: "#fff",
                              border: "none",
                              borderRadius: "50%",
                              width: 24,
                              height: 24,
                              cursor: "pointer",
                              fontSize: 16,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            ×
                          </button>
                        </div>
                      )}

                      <button
                        type="button"
                        className="acp-furnish-btn acp-furnish-btn--all"
                        style={{ width: "100%", justifyContent: "center", height: 40 }}
                        disabled={!trailerVideoData.url.trim()}
                        onClick={addTrailerVideoHandler}
                      >
                        Add Trailer Video
                      </button>
                    </div>

                    <div style={{ background: "#f9fafb", border: "1px solid #e4e7ec", borderRadius: 12, padding: 20, maxHeight: 400, overflowY: "auto" }}>
                      <p style={{ fontSize: 14, fontWeight: 600, color: "#374151", marginBottom: 16 }}>
                        Trailer Videos List
                      </p>
                      {eventPayload.trailer_videos && eventPayload.trailer_videos.length > 0 ? (
                        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                          {eventPayload.trailer_videos.map((item, index) => (
                            <div key={index} style={{ background: "#fff", border: "1px solid #e4e7ec", borderRadius: 10, padding: 14 }}>
                              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 10 }}>
                                <div>
                                  <p style={{ margin: 0, fontSize: 13, fontWeight: 600, color: "#111827" }}>
                                    {item.url.substring(item.url.lastIndexOf("/") + 1)}
                                  </p>
                                  <p style={{ margin: "2px 0 0", fontSize: 12, color: "#6b7280" }}>
                                    Type: {item.type}
                                  </p>
                                </div>
                                <button
                                  type="button"
                                  className="acp-furnish-btn acp-furnish-btn--clear"
                                  style={{ padding: "4px 10px", fontSize: 12 }}
                                  onClick={() => removeTrailerVideo(index)}
                                >
                                  Remove
                                </button>
                              </div>
                              <video controls style={{ width: "100%", borderRadius: 8 }}>
                                <source src={item.url} type="video/mp4" />
                              </video>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <div style={{ textAlign: "center", padding: "32px 0", color: "#9ca3af", fontSize: 14 }}>
                          No trailer videos added yet
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div>
                  <h3 style={{ fontSize: 15, fontWeight: 600, color: "#111827", marginBottom: 16, paddingBottom: 12, borderBottom: "1px solid #e4e7ec" }}>
                    360° VR Content
                  </h3>
                  <div style={{ display: "grid", gridTemplateColumns: "400px 1fr", gap: 24 }}>
                    <div style={{ background: "#f9fafb", border: "1px solid #e4e7ec", borderRadius: 12, padding: 20 }}>
                      <p style={{ fontSize: 14, fontWeight: 600, color: "#374151", marginBottom: 16 }}>
                        Add 360 Content
                      </p>
                      <div className="acp-field" style={{ marginBottom: 14 }}>
                        <label className="acp-label">Configuration</label>
                        <input
                          className="acp-input"
                          type="text"
                          value={threeSixtyData.configuration}
                          onChange={(e) =>
                            setThreeSixtyData({ ...threeSixtyData, configuration: e.target.value })
                          }
                          placeholder="Enter configuration"
                        />
                      </div>
                      <div className="acp-field" style={{ marginBottom: 14 }}>
                        <label className="acp-label">iFrame URL</label>
                        <input
                          className="acp-input"
                          type="text"
                          value={threeSixtyData.iframe_url}
                          onChange={(e) =>
                            setThreeSixtyData({ ...threeSixtyData, iframe_url: e.target.value })
                          }
                          placeholder="Enter iFrame URL"
                        />
                      </div>
                      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 16 }}>
                        <input
                          type="checkbox"
                          id="is_user_vr"
                          checked={threeSixtyData.is_user_vr}
                          onChange={(e) =>
                            setThreeSixtyData({ ...threeSixtyData, is_user_vr: e.target.checked })
                          }
                          style={{ width: 16, height: 16, cursor: "pointer" }}
                        />
                        <label htmlFor="is_user_vr" style={{ fontSize: 13, fontWeight: 500, color: "#374151", cursor: "pointer" }}>
                          Is User VR
                        </label>
                      </div>
                      <button
                        type="button"
                        className="acp-furnish-btn acp-furnish-btn--all"
                        style={{ width: "100%", justifyContent: "center", height: 40 }}
                        disabled={!threeSixtyData.configuration.trim() || !threeSixtyData.iframe_url.trim()}
                        onClick={addThreeSixtyHandler}
                      >
                        Add 360 Content
                      </button>
                    </div>

                    <div style={{ background: "#f9fafb", border: "1px solid #e4e7ec", borderRadius: 12, padding: 20, maxHeight: 400, overflowY: "auto" }}>
                      <p style={{ fontSize: 14, fontWeight: 600, color: "#374151", marginBottom: 16 }}>
                        360 Content List
                      </p>
                      {eventPayload.three_sixty && eventPayload.three_sixty.length > 0 ? (
                        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                          {eventPayload.three_sixty.map((item, index) => (
                            <div
                              key={index}
                              style={{
                                background: "#fff",
                                border: "1px solid #e4e7ec",
                                borderRadius: 10,
                                padding: 14,
                                display: "flex",
                                alignItems: "flex-start",
                                justifyContent: "space-between",
                                gap: 12,
                              }}
                            >
                              <div>
                                <p style={{ margin: 0, fontSize: 13, fontWeight: 600, color: "#111827" }}>
                                  {item.configuration}
                                </p>
                                <p style={{ margin: "3px 0 0", fontSize: 12, color: "#6b7280" }}>
                                  URL: {item.iframe_url}
                                </p>
                                <p style={{ margin: "2px 0 0", fontSize: 12, color: "#6b7280" }}>
                                  VR: {item.is_user_vr ? "Yes" : "No"}
                                </p>
                              </div>
                              <button
                                type="button"
                                className="acp-furnish-btn acp-furnish-btn--clear"
                                style={{ padding: "4px 10px", fontSize: 12, flexShrink: 0 }}
                                onClick={() => removeThreeSixty(index)}
                              >
                                Remove
                              </button>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <div style={{ textAlign: "center", padding: "32px 0", color: "#9ca3af", fontSize: 14 }}>
                          No 360 content added yet
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>

          <div className="acp-card">
            <div className="acp-card-header">
              <span className="acp-card-badge">05</span>
              <h2 className="acp-card-title">Location</h2>
            </div>

            <div className="acp-grid acp-grid-2">
              <div className="acp-field" style={{ gridColumn: "1 / -1" }}>
                <label className="acp-label">
                  Address <span className="acp-req">*</span>
                </label>
                <input
                  className="acp-input"
                  type="text"
                  disabled={!selectedType}
                  name="address"
                  value={eventPayload.address}
                  onChange={handleAddChange}
                  placeholder="Enter full address"
                />
              </div>

              <div className="acp-field" style={{ gridColumn: "1 / -1", marginBottom: 8 }}>
                <MapsAddress
                  disabled={!selectedType}
                  value={{
                    address: eventPayload.address,
                    lat: eventPayload.lat,
                    lng: eventPayload.lng,
                  }}
                  onChange={handleAddressChange}
                  showAsterisk={false}
                />
              </div>

              <div className="acp-field">
                <label className="acp-label">Country</label>
                <select
                  className="acp-select"
                  disabled={!selectedType}
                  name="country"
                  value={eventPayload.country}
                  onChange={handleAddChange}
                >
                  <option value="">Select An Option</option>
                  {Array.isArray(countryList?.data) &&
                    countryList.data.map((country) => (
                      <option value={country._id} key={country._id}>
                        {country.country_name}
                      </option>
                    ))}
                </select>
              </div>

              <div className="acp-field">
                <label className="acp-label">State</label>
                <select
                  className="acp-select"
                  disabled={!eventPayload?.country}
                  name="state"
                  value={eventPayload.state}
                  onChange={handleAddChange}
                >
                  <option value="">Select An Option</option>
                  {Array.isArray(states?.data) &&
                    states.data.map((state) => (
                      <option value={state._id} key={state._id}>
                        {state.state_name}
                      </option>
                    ))}
                </select>
              </div>

              <div className="acp-field">
                <label className="acp-label">City</label>
                <select
                  className="acp-select"
                  disabled={!eventPayload?.state}
                  name="city"
                  value={eventPayload.city}
                  onChange={handleAddChange}
                >
                  <option value="">Select An Option</option>
                  {Array.isArray(cities?.data) &&
                    cities.data.map((city) => (
                      <option key={city._id} value={city._id}>
                        {city.city_name}
                      </option>
                    ))}
                </select>
              </div>
              {/* 
              <div className="acp-field">
                <label className="acp-label">Latitude</label>
                <input
                  className="acp-input"
                  type="text"
                  name="lat"
                  value={eventPayload.lat}
                  readOnly
                  placeholder="Latitude"
                />
              </div>

              <div className="acp-field">
                <label className="acp-label">Longitude</label>
                <input
                  className="acp-input"
                  type="text"
                  name="lng"
                  value={eventPayload.lng}
                  readOnly
                  placeholder="Longitude"
                />
              </div> */}
            </div>
          </div>

          {selectedType?.toLowerCase() !== "trailer" && (
            <div className="acp-card">
              <div className="acp-card-header">
                <span className="acp-card-badge">06</span>
                <h2 className="acp-card-title">Guest Details</h2>
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "400px 1fr", gap: 24 }}>
                <div style={{ background: "#f9fafb", border: "1px solid #e4e7ec", borderRadius: 12, padding: 20 }}>
                  <p style={{ fontSize: 14, fontWeight: 600, color: "#374151", marginBottom: 16 }}>
                    Add Guest
                  </p>
                  <div className="acp-field" style={{ marginBottom: 14 }}>
                    <label className="acp-label">Guest Image</label>
                    <input
                      className="acp-input"
                      type="file"
                      accept="image/jpeg, image/jpg, image/png, image/svg+xml"
                      onChange={(e) => handleMediaUpload(e, "guest_image", "image")}
                    />
                    <ImageShowerModalGlobal
                      state={guestData}
                      setState={setGuestData}
                      keyField="image"
                      file={guestData.image}
                    />
                  </div>

                  <div className="acp-field" style={{ marginBottom: 14 }}>
                    <label className="acp-label">Guest Name</label>
                    <input
                      className="acp-input"
                      type="text"
                      name="name"
                      value={guestData.name}
                      onChange={handleGuestAdd}
                      placeholder="Enter guest name"
                    />
                  </div>

                  <div className="acp-grid acp-grid-2" style={{ marginBottom: 14 }}>
                    <div className="acp-field">
                      <label className="acp-label">Designation</label>
                      <input
                        className="acp-input"
                        type="text"
                        name="designation"
                        onChange={handleGuestAdd}
                        value={guestData.designation}
                        placeholder="e.g. CEO"
                      />
                    </div>
                    <div className="acp-field">
                      <label className="acp-label">Organization</label>
                      <input
                        className="acp-input"
                        onChange={handleGuestAdd}
                        value={guestData.organization}
                        type="text"
                        name="organization"
                        placeholder="Company name"
                      />
                    </div>
                  </div>

                  <button
                    type="button"
                    className="acp-furnish-btn acp-furnish-btn--all"
                    style={{ width: "100%", justifyContent: "center", height: 40 }}
                    disabled={!guestData.name.trim()}
                    onClick={guestAdditionHandler}
                  >
                    Add Guest
                  </button>
                </div>

                <div style={{ background: "#f9fafb", border: "1px solid #e4e7ec", borderRadius: 12, padding: 20, maxHeight: 500, overflowY: "auto" }}>
                  <p style={{ fontSize: 14, fontWeight: 600, color: "#374151", marginBottom: 16 }}>
                    Guest List
                  </p>
                  {eventPayload.guest_list && eventPayload.guest_list.filter((item) => item.name).length > 0 ? (
                    <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                      {eventPayload.guest_list
                        .filter((item) => item.name)
                        .map((item, index) => (
                          <div
                            key={index}
                            style={{
                              background: "#fff",
                              border: "1px solid #e4e7ec",
                              borderRadius: 10,
                              padding: 14,
                              display: "flex",
                              alignItems: "center",
                              gap: 14,
                            }}
                          >
                            <div
                              style={{
                                width: 56,
                                height: 56,
                                borderRadius: 10,
                                overflow: "hidden",
                                background: "#f1f5f9",
                                flexShrink: 0,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              {item.image ? (
                                <img
                                  src={item.image}
                                  alt={item.name}
                                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                />
                              ) : (
                                <span
                                  style={{
                                    fontSize: 22,
                                    fontWeight: 700,
                                    color: "#fff",
                                    background: "linear-gradient(135deg, #3b82f6, #8b5cf6)",
                                    width: "100%",
                                    height: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  {item.name.charAt(0).toUpperCase()}
                                </span>
                              )}
                            </div>

                            <div style={{ flex: 1, minWidth: 0 }}>
                              <p style={{ margin: 0, fontSize: 14, fontWeight: 600, color: "#111827" }}>
                                {item.name}
                              </p>
                              <p style={{ margin: "3px 0 0", fontSize: 12, color: "#6b7280" }}>
                                {item.designation}
                                {item.designation && item.organization && " at "}
                                {item.organization}
                              </p>
                            </div>

                            <button
                              type="button"
                              className="acp-furnish-btn acp-furnish-btn--clear"
                              style={{ padding: "4px 10px", fontSize: 12 }}
                              onClick={() =>
                                setEventPayload((prevData) => ({
                                  ...prevData,
                                  guest_list: prevData.guest_list.filter((_, i) => i !== index),
                                }))
                              }
                            >
                              Remove
                            </button>
                          </div>
                        ))}
                    </div>
                  ) : (
                    <div style={{ textAlign: "center", padding: "32px 0", color: "#9ca3af", fontSize: 14 }}>
                      No guests added yet
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}

          <div className="acp-footer">
            <Link to="/event" className="acp-btn acp-btn--cancel">
              Cancel
            </Link>
            <button type="submit" className="acp-btn acp-btn--submit">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <polyline points="20 6 9 17 4 12" />
              </svg>
              {isTrailer ? "Save Trailer" : isComingSoon ? "Save Coming Soon" : "Save Event"}
            </button>
          </div>
        </form>
      </div>
    </MainLayout>
  );
};

export default AddEvents;

//